module.exports = __webpack_public_path__ + "static/media/1006059.0765112d.png";